import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { MarcheDTO } from "../core/model/marche/marche-dto";
import { MarcheService } from "../core/service/marche.service";

@Component({
  selector: "app-marche",
  templateUrl: "./marche.component.html",
  styleUrls: ["./marche.component.scss"],
})
export class MarcheComponent implements OnInit {
  marches: MarcheDTO[];

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _marcheService: MarcheService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.getMarches();
  }

  getMarches() {
    this._marcheService.findAll().subscribe(
      (data) => {
        this.marches = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
